import React from 'react';
import Layout from '~/Components/Layout/Layout';

import './invitation.scss';

const NoInvitation = () => {

    const containerStyle = {backgroundImage: ''};

    return (
        <Layout containerStyle={containerStyle} noPadding page="invitation">
            <div className="container container-invitation">

                <div className="row">

                    <div className="col-lg-9 col-12">

                        <div className="row">
                            <div className="col-lg-7 col-12 col-left">
                                <h3 className="mb-0 text-primary">Sorry! This user has no invitations!</h3>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </Layout>
    );
}

export default NoInvitation;
